import { useState } from 'react';
import OTPVerification from './OTPVerification';
import './Auth.css';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

function Signup({ onSignupSuccess, onSwitchToLogin, referralCode }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    referral_code: referralCode || ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/signup/request-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          full_name: formData.full_name,
          referral_code: formData.referral_code || null,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setStep(2);
      } else {
        setError(data.detail || 'Signup failed');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  if (step === 2) {
    return (
      <OTPVerification
        email={formData.email}
        onVerify={async (otpCode) => {
          const response = await fetch(`${API_URL}/signup/verify-otp`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: formData.email, otp: otpCode })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.detail || 'OTP verification failed');
          localStorage.setItem('token', data.access_token);
          localStorage.setItem('user', JSON.stringify(data.user));
          if (onSignupSuccess) onSignupSuccess(data.user);
        }}
        onResend={async () => {
          const response = await fetch(`${API_URL}/signup/request-otp`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          });
          if (!response.ok) throw new Error('Failed to resend OTP');
        }}
        onBack={() => setStep(1)}
        verificationType="signup"
      />
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Logo */}
        <div className="auth-header">
          <div className="auth-logo">🎬</div>
          <h1>NETHAJI PRIME</h1>
          <h2>Join Us!</h2>
          <p>Create your free account today</p>
        </div>

        {/* Referral bonus banner */}
        {referralCode && (
          <div style={{ background: 'rgba(0,212,128,0.1)', border: '1px solid #00d480', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', textAlign: 'center' }}>
            <p style={{ color: '#00d480', fontSize: '14px', fontWeight: '600', margin: 0 }}>
              🎁 You were invited! Sign up for <strong>10 days free</strong> instead of 7!
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder="Your full name"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="At least 6 characters"
                required
                minLength="6"
                style={{ paddingRight: '48px', width: '100%', boxSizing: 'border-box' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '16px', padding: '0' }}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* Referral code field */}
          <div className="form-group">
            <label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>Referral Code <span style={{ color: '#666', fontWeight: '400' }}>(optional)</span></span>
              {formData.referral_code && <span style={{ color: '#00d480', fontSize: '11px' }}>🎁 +3 bonus days!</span>}
            </label>
            <input
              type="text"
              name="referral_code"
              value={formData.referral_code}
              onChange={handleChange}
              placeholder="Enter referral code"
              style={{ textTransform: 'uppercase' }}
            />
          </div>

          {error && <div className="error-message">❌ {error}</div>}

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? '⏳ Sending OTP...' : '🚀 Create Account'}
          </button>
        </form>

        <div className="auth-footer">
          <p style={{ color: '#666', fontSize: '12px', marginBottom: '12px' }}>
            ✅ {referralCode ? '10-day' : '7-day'} free trial • No credit card required
          </p>
          <p>
            Already have an account?{' '}
            <button type="button" className="auth-link" onClick={onSwitchToLogin}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              Login
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;